import { render, staticRenderFns } from "./order_referral_form.vue?vue&type=template&id=46ded2d4&"
import script from "./order_referral_form.vue?vue&type=script&lang=js&"
export * from "./order_referral_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports